import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

interface KycRejectionAlertProps {
  reason: string;
}

export function KycRejectionAlert({ reason }: KycRejectionAlertProps) {
  const { t } = useTranslation('kyc');

  return (
    <div className="rounded-xl border border-[var(--danger)]/30 bg-[var(--danger-bg)] p-4 flex gap-3">
      <X className="size-5 text-[var(--danger)] mt-0.5 shrink-0" aria-hidden />
      <div className="min-w-0">
        <p className="text-[13px] font-semibold text-[var(--danger)]">
          {t('rejection.reasonLabel')}
        </p>
        <p className="text-[12px] text-[var(--text-secondary)] mt-1 break-words">{reason}</p>
      </div>
    </div>
  );
}
